import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import { generarNombreArchivo } from "./nombrePDF";
import { obtenerDatosTenantPDF } from "./tenantPDF";

// ─── Paleta de colores ───────────────────────────────────────────────────────
const PALETTE = {
  remDark:    [139, 132, 121], // Greige oscuro
  remLight:   [183, 177, 166], // Greige claro
  remBanda:   [244, 241, 230], // Banda Greige cálida
  success:    [22, 163, 74],   // Verde
  danger:     [220, 38, 38],   // Rojo
  warning:    [217, 119, 6],   // Ámbar
  dark:       [33, 37, 41],
  grayText:   [75, 85, 99],
  grayLabel:  [140, 145, 155],
  hairline:   [229, 231, 235],
};

const REDES_PDF = {
  instagram: { bg: "#E1306C", bgArr: [225, 48, 108] },
  facebook:  { bg: "#1877F2", bgArr: [24, 119, 242] },
  tiktok:    { bg: "#010101", bgArr: [1, 1, 1] },
  youtube:   { bg: "#FF0000", bgArr: [255, 0, 0] },
  whatsapp:  { bg: "#25D366", bgArr: [37, 211, 102] },
  web:       { bg: "#0077B6", bgArr: [0, 119, 182] },
};

function generarIconoRed(red, size = 48) {
  const canvas = document.createElement("canvas");
  canvas.width = size;
  canvas.height = size;
  const ctx = canvas.getContext("2d");
  const cfg = REDES_PDF[red];
  if (!cfg) return null;

  const r = size * 0.2;
  ctx.fillStyle = cfg.bg;
  ctx.beginPath();
  ctx.moveTo(r, 0);
  ctx.lineTo(size - r, 0);
  ctx.quadraticCurveTo(size, 0, size, r);
  ctx.lineTo(size, size - r);
  ctx.quadraticCurveTo(size, size, size - r, size);
  ctx.lineTo(r, size);
  ctx.quadraticCurveTo(0, size, 0, size - r);
  ctx.lineTo(0, r);
  ctx.quadraticCurveTo(0, 0, r, 0);
  ctx.closePath();
  ctx.fill();

  ctx.fillStyle = "#FFFFFF";
  ctx.strokeStyle = "#FFFFFF";
  const cx = size / 2;
  const cy = size / 2;
  const u = size / 48;

  if (red === "instagram") {
    ctx.lineWidth = 2.5 * u;
    const boxS = 22 * u;
    const boxR = 6 * u;
    ctx.beginPath();
    ctx.moveTo(cx - boxS/2 + boxR, cy - boxS/2);
    ctx.lineTo(cx + boxS/2 - boxR, cy - boxS/2);
    ctx.quadraticCurveTo(cx + boxS/2, cy - boxS/2, cx + boxS/2, cy - boxS/2 + boxR);
    ctx.lineTo(cx + boxS/2, cy + boxS/2 - boxR);
    ctx.quadraticCurveTo(cx + boxS/2, cy + boxS/2, cx + boxS/2 - boxR, cy + boxS/2);
    ctx.lineTo(cx - boxS/2 + boxR, cy + boxS/2);
    ctx.quadraticCurveTo(cx - boxS/2, cy + boxS/2, cx - boxS/2, cy + boxS/2 - boxR);
    ctx.lineTo(cx - boxS/2, cy - boxS/2 + boxR);
    ctx.quadraticCurveTo(cx - boxS/2, cy - boxS/2, cx - boxS/2 + boxR, cy - boxS/2);
    ctx.closePath();
    ctx.stroke();
    ctx.beginPath();
    ctx.arc(cx, cy, 7 * u, 0, Math.PI * 2);
    ctx.stroke();
    ctx.beginPath();
    ctx.arc(cx + 8 * u, cy - 8 * u, 2 * u, 0, Math.PI * 2);
    ctx.fill();
  } else if (red === "facebook") {
    ctx.font = `bold ${28 * u}px Arial`;
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    ctx.fillText("f", cx + 1 * u, cy + 2 * u);
  } else if (red === "tiktok") {
    ctx.font = `bold ${26 * u}px Arial`;
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    ctx.fillText("♪", cx, cy + 1 * u);
  } else if (red === "youtube") {
    ctx.beginPath();
    ctx.moveTo(cx - 6 * u, cy - 9 * u);
    ctx.lineTo(cx - 6 * u, cy + 9 * u);
    ctx.lineTo(cx + 10 * u, cy);
    ctx.closePath();
    ctx.fill();
  } else if (red === "whatsapp") {
    ctx.font = `${22 * u}px Arial`;
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    ctx.fillText("✆", cx, cy + 1 * u);
  } else if (red === "web") {
    ctx.lineWidth = 2 * u;
    ctx.beginPath();
    ctx.arc(cx, cy, 10 * u, 0, Math.PI * 2);
    ctx.stroke();
    ctx.beginPath();
    ctx.moveTo(cx - 10 * u, cy);
    ctx.lineTo(cx + 10 * u, cy);
    ctx.stroke();
    ctx.beginPath();
    ctx.ellipse(cx, cy, 5 * u, 10 * u, 0, 0, Math.PI * 2);
    ctx.stroke();
  }
  return canvas.toDataURL("image/png");
}

const money = (n) => `$${Number(n || 0).toLocaleString("es-CO")}`;
const soloFecha = (f) => {
  if (!f) return "—";
  if (f instanceof Date) {
    const dd = String(f.getDate()).padStart(2, "0");
    const mm = String(f.getMonth() + 1).padStart(2, "0");
    const yy = f.getFullYear();
    return `${dd}/${mm}/${yy}`;
  }
  const s = String(f).trim();
  const iso = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (iso) return `${iso[3]}/${iso[2]}/${iso[1]}`;
  const dmy = s.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
  if (dmy) return `${dmy[1].padStart(2, "0")}/${dmy[2].padStart(2, "0")}/${dmy[3]}`;
  const d = new Date(s);
  if (!isNaN(d)) {
    const dd = String(d.getDate()).padStart(2, "0");
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const yy = d.getFullYear();
    return `${dd}/${mm}/${yy}`;
  }
  return "—";
};

const procesarImagen = (src, width = 150, calidad = 1.0) =>
  new Promise((resolve) => {
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = () => {
      const canvas = document.createElement("canvas");
      const escala = width / img.width;
      canvas.width = width;
      canvas.height = img.height * escala;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
      resolve(canvas.toDataURL("image/png", calidad));
    };
    img.src = src;
  });

export const generarPDFRecepcion = async (revision, clienteInput, productosRecibidos, ingresosAdicionales = [], pagosProveedoresRecepcion = [], garantiaInfo = {}, gastosAdicionales = []) => {
  const doc = new jsPDF();
  const pageW = doc.internal.pageSize.getWidth();
  const pageH = doc.internal.pageSize.getHeight();

  const emp = await obtenerDatosTenantPDF();
  const logo = emp.logoUrl ? await procesarImagen(emp.logoUrl, 250, 1.0) : null;
  const fondo = emp.fondoUrl ? await procesarImagen(emp.fondoUrl, 300, 0.9) : null;

  const insertarFondo = () => {
    if (!fondo) return;
    const centerX = (pageW - 150) / 2;
    const centerY = (pageH - 150) / 2;
    doc.saveGraphicsState();
    doc.setGState(new doc.GState({ opacity: 0.06 }));
    doc.addImage(fondo, "PNG", centerX, centerY, 150, 150);
    doc.restoreGraphicsState();
  };
  insertarFondo();

  const T = { dark: PALETTE.remDark, light: PALETTE.remLight, banda: PALETTE.remBanda };

  const MARGIN_X = 14;
  const MARGIN_TOP = 10;
  const rightMarginX = pageW - MARGIN_X;

  const bandaH = 26;
  doc.setFillColor(...T.banda);
  doc.rect(0, MARGIN_TOP, pageW, bandaH, "F");
  doc.setFillColor(...T.dark);
  doc.rect(0, MARGIN_TOP, pageW, 1.2, "F");

  if (logo) {
    const logoSize = 32;
    const logoX = MARGIN_X;
    const logoY = MARGIN_TOP + 4;
    doc.setFillColor(255, 255, 255);
    doc.circle(logoX + logoSize / 2, logoY + logoSize / 2, (logoSize / 2) + 1.5, "F");
    doc.addImage(logo, "PNG", logoX, logoY, logoSize, logoSize);
  }

  const infoX = MARGIN_X + 38;
  doc.setFont("helvetica", "bold");
  doc.setFontSize(14);
  doc.setTextColor(...PALETTE.dark);
  doc.text(emp.nombre || "", infoX, MARGIN_TOP + 11);

  doc.setFont("helvetica", "normal");
  doc.setFontSize(9.5);
  doc.setTextColor(...PALETTE.grayText);
  doc.text(emp.direccion || "", infoX, MARGIN_TOP + 16);
  doc.text(emp.telefono ? `Cel-Whatsapp ${emp.telefono}` : "", infoX, MARGIN_TOP + 20.5);

  const fechaRevision = soloFecha(revision?.fecha || new Date());

  doc.setFont("helvetica", "bold");
  doc.setFontSize(11.5);
  doc.setTextColor(100, 110, 120);
  doc.text("RECEPCIÓN", rightMarginX, MARGIN_TOP + 13.5, { align: "right" });

  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.setTextColor(...PALETTE.grayText);
  doc.text(`Fecha revisión: ${fechaRevision}`, rightMarginX, MARGIN_TOP + 18.5, { align: "right" });

  doc.setFont("helvetica", "normal");
  doc.setTextColor(0, 0, 0);

  const cliente = clienteInput || {};

  const renderField = (label, valor, x, y, maxW) => {
    doc.setFont("helvetica", "normal");
    doc.setFontSize(7);
    doc.setTextColor(...PALETTE.grayLabel);
    doc.text(String(label).toUpperCase(), x, y);
    doc.setFontSize(10);
    doc.setTextColor(...PALETTE.dark);
    const v = doc.splitTextToSize(String(valor || "—"), maxW)[0];
    doc.text(v, x, y + 4.2);
    return { x, y: y + 4.2, w: doc.getTextWidth(v) };
  };

  const yData = MARGIN_TOP + 42;
  const colLeftX = MARGIN_X;
  const colRightX = 125;
  const colW = 75;
  const fieldGap = 9;        

  const filasIzq = [
    ["Cliente", cliente.nombre || "N/A"],
    ["Identificación", cliente.identificacion || "N/A"],
    ["Teléfono", cliente.telefono || "N/A"],
  ];
  
  const fEvt = revision?.fecha_evento ? soloFecha(revision.fecha_evento) : "—";
  const filasDer = [
    ["Correo", cliente.email || "N/A"],
    ["Dirección", cliente.direccion || "N/A"],
    ["Fecha del evento", fEvt],
  ];

  filasIzq.forEach((f, i) => renderField(f[0], f[1], colLeftX, yData + i * fieldGap, colW));
  filasDer.forEach((f, i) => renderField(f[0], f[1], colRightX, yData + i * fieldGap, colW));

  const yAfterCols = yData + 3 * fieldGap;

  doc.setDrawColor(...PALETTE.hairline);
  doc.setLineWidth(0.2);
  doc.line(MARGIN_X, yAfterCols, rightMarginX, yAfterCols);

  const yEvtRow = yAfterCols + 4;
  const hayLugar = !!revision?.lugar_evento;
  const hayTipo = !!revision?.tipo_evento;

  if (hayTipo) {
    renderField("Tipo de evento", revision.tipo_evento, colLeftX, yEvtRow, colW);
  }
  if (hayLugar) {
    const r = renderField("Lugar del evento", revision.lugar_evento, colRightX, yEvtRow, colW);
    const mapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(revision.lugar_evento)}`;
    doc.link(r.x, r.y - 3.5, r.w, 5, { url: mapsUrl });
  }

  const yPostEvtRow = (hayLugar || hayTipo) ? yEvtRow + fieldGap : yAfterCols + 2;
  const startYTabla = yPostEvtRow + 3;

  const tableLeftX = MARGIN_X;
  const tableRightX = rightMarginX;
  const tableW = tableRightX - tableLeftX;

  const applyHeaderGradient = (data, leftX = tableLeftX, width = tableW) => {
    if (data.section === "head") {
      const { x, y, width: cellW, height } = data.cell;
      const steps = Math.max(20, Math.ceil(cellW));
      const stripW = cellW / steps;
      for (let i = 0; i < steps; i++) {
        const localX = i * stripW;
        const globalX = x + localX - leftX;
        const t = Math.max(0, Math.min(1, globalX / width));
        const r = Math.round(T.dark[0] + t * (T.light[0] - T.dark[0]));
        const g = Math.round(T.dark[1] + t * (T.light[1] - T.dark[1]));
        const b = Math.round(T.dark[2] + t * (T.light[2] - T.dark[2]));
        doc.setFillColor(r, g, b);
        doc.rect(x + localX, y, stripW + 0.2, height, "F");
      }
    }
  };

  let zebraIndex = 0;
  autoTable(doc, {
    head: [["Descripción", "Esperado", "Recibido", "Observación"]],
    body: (productosRecibidos || []).map((p) => [
      p.descripcion || "—",
      p.esperado ?? "—",
      p.recibido ?? "—",
      (p.observacion && String(p.observacion).trim()) || "—",
    ]),
    startY: startYTabla,
    styles: { font: "helvetica", fontSize: 9.5, cellPadding: 1.5, textColor: PALETTE.dark },
    headStyles: {
      fillColor: false, 
      textColor: 255,
      halign: "center",
      valign: "middle",
      fontStyle: "bold",
      fontSize: 9.5,
      cellPadding: { top: 3, bottom: 3, left: 2.5, right: 2.5 },
      minCellHeight: 9,
    },
    columnStyles: {
      0: { cellWidth: 78 },
      1: { cellWidth: 26, halign: "center" },
      2: { cellWidth: 26, halign: "center" },
      3: { cellWidth: 52, halign: "left" }, 
    },
    margin: { left: MARGIN_X, right: MARGIN_X }, 
    didParseCell: (data) => {
      const { section, column, cell, row, table } = data;
      if (section === "body") {
        const shade = zebraIndex % 2 === 0 ? 255 : 248;
        cell.styles.fillColor = [shade, shade, shade];
        if (column.index === 3 && (!row.raw[3] || row.raw[3] === "—")) {
          cell.styles.halign = "center";
        }
        if (column.index === table.columns.length - 1) zebraIndex++;
      }
    },
    willDrawCell: (data) => applyHeaderGradient(data),
    didDrawPage: insertarFondo,
  });

  let y = (doc.lastAutoTable?.finalY || 100) + 10;

  const garantiaTotal = Number(garantiaInfo.garantiaTotal || revision?.garantia || 0);
  const garantiaRetenidaVal = Number(garantiaInfo.garantiaRetenida || 0);
  const garantiaDevuelta = Math.max(0, garantiaTotal - garantiaRetenidaVal);

  if (garantiaTotal > 0) {
    if (y + 35 > pageH - 15) { doc.addPage(); insertarFondo(); y = 20; }
    
    zebraIndex = 0;
    autoTable(doc, {
      startY: y,
      head: [["Concepto", "Valor ($)"]],
      body: [
        ["Garantía entregada por el cliente", money(garantiaTotal)],
        ["Monto retenido (daños/demora)", garantiaRetenidaVal > 0 ? money(garantiaRetenidaVal) : "$0"],
        ["Devuelto al cliente", money(garantiaDevuelta)],
      ],
      styles: { font: "helvetica", fontSize: 9.5, cellPadding: 1.5, textColor: PALETTE.dark },
      headStyles: { fillColor: false, textColor: 255, halign: "center", valign: "middle", fontStyle: "bold", fontSize: 9.5, minCellHeight: 9 },
      columnStyles: {
        0: { cellWidth: 130 },
        1: { cellWidth: 52, halign: "right" },
      },
      margin: { left: MARGIN_X, right: MARGIN_X },
      didParseCell: (data) => {
        const { section, row, cell, column, table } = data;
        if (section === "body") {
          const shade = zebraIndex % 2 === 0 ? 255 : 248;
          cell.styles.fillColor = [shade, shade, shade];
          if (row.index === 1 && garantiaRetenidaVal > 0) {
            cell.styles.textColor = PALETTE.danger;
            cell.styles.fontStyle = "bold";
          }
          if (row.index === 2) {
            cell.styles.textColor = PALETTE.success;
            cell.styles.fontStyle = "bold";
          }
          if (column.index === table.columns.length - 1) zebraIndex++;
        }
      },
      willDrawCell: (data) => applyHeaderGradient(data),
    });
    y = doc.lastAutoTable.finalY + 10;
  }

  const abonos = Array.isArray(revision?.abonos) ? revision.abonos : [];
  let totalIngresos = 0;

  const ingresosRows = abonos.map((a, i) => {
    const valor = Number(a?.valor ?? a ?? 0);
    const fecha = a?.fecha ? soloFecha(a.fecha) : "—";
    totalIngresos += valor;
    return [`Abono ${i + 1}`, fecha, money(valor)];
  });

  ingresosAdicionales.forEach((ing, i) => {
    const valor = Number(ing.valor || 0);
    if (valor > 0) {
      const concepto = ing.motivo?.trim() ? ing.motivo.trim() : `Pago en recepción ${i + 1}`;
      ingresosRows.push([concepto, ing.fecha ? soloFecha(ing.fecha) : "—", money(valor)]);
      totalIngresos += valor;
    }
  });

  if (garantiaRetenidaVal > 0) {
    ingresosRows.push(["Garantía retenida (daños/demora)", soloFecha(new Date()), money(garantiaRetenidaVal)]);
    totalIngresos += garantiaRetenidaVal;
  }

  if (y + 40 > pageH - 15) { doc.addPage(); insertarFondo(); y = 20; }

  zebraIndex = 0;
  autoTable(doc, {
    startY: y,
    head: [["Concepto", "Fecha", "Valor ($)"]],
    body: ingresosRows.length ? ingresosRows : [["—", "—", money(0)]],
    foot: [["TOTAL INGRESOS", "", money(totalIngresos)]],
    styles: { font: "helvetica", fontSize: 9.5, cellPadding: 1.5, textColor: PALETTE.dark },
    headStyles: { fillColor: false, textColor: 255, halign: "center", valign: "middle", fontStyle: "bold", fontSize: 9.5, minCellHeight: 9 },
    columnStyles: {
      0: { cellWidth: 92 },
      1: { cellWidth: 40, halign: "center" },
      2: { cellWidth: 50, halign: "right" },
    },
    margin: { left: MARGIN_X, right: MARGIN_X },
    didParseCell: (data) => {
      const { section, column, cell, table } = data;
      if (section === "body") {
        const shade = zebraIndex % 2 === 0 ? 255 : 248;
        cell.styles.fillColor = [shade, shade, shade];
        if (column.index === table.columns.length - 1) zebraIndex++;
      }
      if (section === "foot") {
        cell.styles.fillColor = [250, 250, 249];
        cell.styles.fontStyle = "bold";
        cell.styles.fontSize = 10.5;
        if (column.index === 2) cell.styles.textColor = PALETTE.success;
      }
    },
    willDrawCell: (data) => applyHeaderGradient(data),
  });
  y = doc.lastAutoTable.finalY + 10;

  let totalGastos = 0;
  const gastosRows = [];
  const pagosProveedoresOrden = revision?.pagos_proveedores || [];

  pagosProveedoresOrden.forEach((prov) => {
    (prov.abonos || []).forEach((abono) => {
      const valor = Number(abono.valor || 0);
      if (valor > 0) {
        gastosRows.push([`Pago a ${prov.proveedor_nombre}`, abono.fecha ? soloFecha(abono.fecha) : "—", money(valor)]);
        totalGastos += valor;
      }
    });
  });

  (pagosProveedoresRecepcion || []).forEach((pago) => {
    const valor = Number(pago.abono_recepcion || 0);
    if (valor > 0) {
      gastosRows.push([`Pago a ${pago.proveedor_nombre} (recepción)`, pago.fecha_abono_recepcion ? soloFecha(pago.fecha_abono_recepcion) : soloFecha(new Date()), money(valor)]);
      totalGastos += valor;
    }
  });

  if (Number(revision?.descuento) > 0) {
    gastosRows.push(["Descuento aplicado", "—", money(Number(revision.descuento))]);
    totalGastos += Number(revision.descuento);
  }

  if (Number(revision?.retencion) > 0) {
    gastosRows.push(["Retención legal", "—", money(Number(revision.retencion))]);
    totalGastos += Number(revision.retencion);
  }

  // Gastos adicionales escritos a mano en la recepción. Se guardan en la columna
  // gastos_extras_recepcion del pedido y en contabilidad como "Gasto adicional
  // (manual)", pero antes el PDF no los conocía y la ganancia salía inflada.
  // Los gastos guardados antes del Bloque Y no tienen fecha: en esos sale "—".
  (gastosAdicionales || []).forEach((gasto) => {
    const valor = Number(gasto.valor || 0);
    if (gasto.motivo && valor > 0) {
      gastosRows.push([gasto.motivo, gasto.fecha ? soloFecha(gasto.fecha) : "—", money(valor)]);
      totalGastos += valor;
    }
  });

  if (y + 40 > pageH - 15) { doc.addPage(); insertarFondo(); y = 20; }

  zebraIndex = 0;
  autoTable(doc, {
    startY: y,
    head: [["Concepto", "Fecha", "Valor ($)"]],
    body: gastosRows.length ? gastosRows : [["—", "—", money(0)]],
    foot: [["TOTAL GASTOS", "", money(totalGastos)]],
    styles: { font: "helvetica", fontSize: 9.5, cellPadding: 1.5, textColor: PALETTE.dark },
    headStyles: { fillColor: false, textColor: 255, halign: "center", valign: "middle", fontStyle: "bold", fontSize: 9.5, minCellHeight: 9 },
    columnStyles: {
      0: { cellWidth: 92 },
      1: { cellWidth: 40, halign: "center" },
      2: { cellWidth: 50, halign: "right" },
    },
    margin: { left: MARGIN_X, right: MARGIN_X },
    didParseCell: (data) => {
      const { section, column, cell, table } = data;
      if (section === "body") {
        const shade = zebraIndex % 2 === 0 ? 255 : 248;
        cell.styles.fillColor = [shade, shade, shade];
        if (column.index === table.columns.length - 1) zebraIndex++;
      }
      if (section === "foot") {
        cell.styles.fillColor = [250, 250, 249];
        cell.styles.fontStyle = "bold";
        cell.styles.fontSize = 10.5;
        if (column.index === 2) cell.styles.textColor = PALETTE.danger;
      }
    },
    willDrawCell: (data) => applyHeaderGradient(data),
  });
  y = doc.lastAutoTable.finalY + 12;

  const gananciaNeta = totalIngresos - totalGastos;
  const miniWidth = 120;
  const leftMarginGN = (pageW - miniWidth) / 2;

  if (y + 25 > pageH - 15) { doc.addPage(); insertarFondo(); y = 20; }

  autoTable(doc, {
    startY: y,
    head: [["GANANCIA NETA FINAL ($)"]],
    body: [[money(gananciaNeta)]],
    styles: { font: "helvetica", fontSize: 11, cellPadding: 3 },
    headStyles: { fillColor: false, textColor: 255, halign: "center", valign: "middle", fontStyle: "bold", minCellHeight: 10 },
    bodyStyles: {
      fillColor: [248, 250, 252],
      halign: "center",
      fontStyle: "bold",
      fontSize: 14,
      textColor: gananciaNeta >= 0 ? PALETTE.success : PALETTE.danger,
    },
    tableWidth: miniWidth,
    margin: { left: leftMarginGN, right: leftMarginGN },
    willDrawCell: (data) => applyHeaderGradient(data, leftMarginGN, miniWidth),
  });
  
  y = doc.lastAutoTable.finalY + 20;

  const safeBottom = pageH - 15;
  if (y + 30 > safeBottom) { doc.addPage(); insertarFondo(); y = 25; }

  doc.setFont("helvetica", "bold");
  doc.setFontSize(10);
  doc.setTextColor(...PALETTE.dark);
  
  doc.text("Firma de quien recibe:", MARGIN_X, y);
  doc.setDrawColor(...PALETTE.dark);
  doc.setLineWidth(0.3);
  doc.line(MARGIN_X, y + 10, MARGIN_X + 65, y + 10);
  
  const lblCli = "Firma del cliente:";
  doc.text(lblCli, rightMarginX - 65, y);
  doc.line(rightMarginX - 65, y + 10, rightMarginX, y + 10);
  
  y += 24;

  // ═════════════════════════════════════════════════════════════════════════
  // TÉRMINOS Y CONDICIONES Y REDES
  // ═════════════════════════════════════════════════════════════════════════
  let altoTerminos = 16; 
  if (revision?.fecha_entrega || revision?.fecha_devolucion) altoTerminos += 6.5;
  
  let lineasCond = [];
  if (emp.textoCondicionesPdf) {
    doc.setFontSize(10); 
    lineasCond = doc.splitTextToSize(emp.textoCondicionesPdf, pageW - (MARGIN_X * 2));
    altoTerminos += lineasCond.length * 5 + 4;
  }
  
  const altoRedes = 30; 
  const altoBloqueCentrado = altoTerminos + altoRedes;

  if (y + altoBloqueCentrado > safeBottom) {
    doc.addPage();
    insertarFondo();
    y = (pageH - altoBloqueCentrado) / 2;
  } else {
    const spaceLeft = safeBottom - y - altoBloqueCentrado;
    if (spaceLeft > 15) {
      y += spaceLeft / 2.5; 
    }
  }

  let yT = y;
  const centerX = pageW / 2;

  if (emp.textoCondicionesPdf || revision?.fecha_entrega || revision?.fecha_devolucion) {
      doc.setFont("helvetica", "bold");
      doc.setFontSize(11.5); 
      doc.setTextColor(...PALETTE.grayLabel);
      doc.text("TÉRMINOS Y CONDICIONES", centerX, yT, { align: "center" });

      doc.setDrawColor(...PALETTE.hairline);
      doc.setLineWidth(0.3);
      doc.line(centerX - 45, yT + 2, centerX + 45, yT + 2);
      yT += 9;

      doc.setFontSize(10.5); 
      let datesText = "";
      if (revision?.fecha_entrega) datesText += `Entrega: ${soloFecha(revision.fecha_entrega)}`;
      if (revision?.fecha_devolucion) {
          if (datesText) datesText += `   |   `;
          datesText += `Devolución: ${soloFecha(revision.fecha_devolucion)}`;
      }

      if (datesText) {
          doc.setTextColor(...PALETTE.grayText);
          doc.text(datesText, centerX, yT, { align: "center" });
          yT += 6.5;
      }

      if (emp.textoCondicionesPdf) {
          yT += 2;
          doc.setFontSize(10); 
          doc.setTextColor(...PALETTE.grayText);
          lineasCond.forEach((linea, i) => {
            doc.text(linea, centerX, yT + i * 5, { align: "center" });
          });
          yT += lineasCond.length * 5;
      }
      yT += 6; 
  }

  doc.setDrawColor(...PALETTE.hairline);
  doc.setLineWidth(0.3);
  doc.line(centerX - 60, yT, centerX + 60, yT); 
  yT += 8;

  const redes = (emp.redesSociales || []).filter(r => r.usuario && REDES_PDF[r.red]);
  if (redes.length > 0) {
    const iconSize = 5.5;
    const gap = 8;
    const redesConIcono = redes.map((red) => {
      const icono = generarIconoRed(red.red, 48);
      const texto = red.usuario;
      const textoW = doc.getStringUnitWidth(texto) * 9.5 / doc.internal.scaleFactor;
      const pillW = iconSize + 2 + textoW;
      return { red, icono, texto, textoW, pillW };
    });
    const totalWidth = redesConIcono.reduce((acc, r) => acc + r.pillW, 0) + (redes.length - 1) * gap;
    let xPill = (pageW - totalWidth) / 2;

    redesConIcono.forEach(({ icono, texto, pillW }) => {
      if (icono) {
        try { doc.addImage(icono, "PNG", xPill, yT - 4, iconSize, iconSize); } catch (e) {}
      }
      doc.setFontSize(9.5);
      doc.setTextColor(...PALETTE.grayText);
      doc.text(texto, xPill + iconSize + 2, yT);
      xPill += pillW + gap;
    });
  } else if (emp.email) {
    doc.setFontSize(9);
    doc.setTextColor(...PALETTE.grayText);
    doc.text(emp.email, centerX, yT, { align: "center" });
  }

  doc.setTextColor(0, 0, 0);

  const nombreArchivo = generarNombreArchivo("recepcion", revision?.fecha || new Date(), cliente?.nombre);
  doc.save(nombreArchivo);
};

export default generarPDFRecepcion;